import api from './axios';
import { 
  User, 
  CreateUserRequest, 
  UpdateUserRequest, 
  PaginatedResponse
} from '../types';

export class UsersService {
  async getUsers(
    cursor?: string,
    limit = 10, 
    search?: string, 
    role?: string
  ): Promise<PaginatedResponse<User>> {
    const params = new URLSearchParams();
    params.append('limit', limit.toString());
    
    if (cursor) params.append('cursor', cursor);
    if (search) params.append('search', search);
    if (role) params.append('role', role);
    
    const response = await api.get<PaginatedResponse<User>>(`/users?${params}`);
    return response.data;
  }

  async getUserById(id: string): Promise<User> {
    const response = await api.get<User>(`/users/${id}`);
    return response.data;
  }

  async createUser(userData: CreateUserRequest): Promise<User> {
    const response = await api.post<User>('/users', userData);
    return response.data;
  }

  async updateUser(userData: UpdateUserRequest): Promise<User> {
    const { id, ...updateData } = userData;
    const response = await api.patch<User>(`/users/${id}`, updateData);
    return response.data;
  }

  async deleteUser(id: string): Promise<void> {
    await api.delete(`/users/${id}`);
  }

  async activateUser(id: string): Promise<User> {
    const response = await api.patch<User>(`/users/${id}/activate`);
    return response.data;
  }

  async deactivateUser(id: string): Promise<User> {
    const response = await api.patch<User>(`/users/${id}/deactivate`);
    return response.data;
  }

  async resetPassword(id: string, password: string): Promise<User> {
    const response = await api.patch<User>(`/users/${id}/reset-password`, {
      password
    });
    return response.data;
  }

  async exportUsers(format = 'csv'): Promise<Blob> {
    const response = await api.get(`/users/export?format=${format}`, {
      responseType: 'blob'
    });
    return response.data;
  }
}

export const usersService = new UsersService();
